import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getWebhooksListFetchSuccess, getWebhooksListFetchFailure } from './reducer';
import { WebhooksListResType } from 'src/types/webhooksList';

const getWebhooksListFetchRequest = async () => {
    const res = await api('get', 'api/secure/webhooks');
    return res.data.data;
};

function* getWebhooksListFetch() {
    try {
        const response: WebhooksListResType['data'] = yield call((): any => getWebhooksListFetchRequest());
        yield put(getWebhooksListFetchSuccess(response));
    } catch (error) {
        yield put(getWebhooksListFetchFailure({ error }));
    }
}

export function* getWebhooksListFetchWatch() {
    yield takeEvery('webhooksList/getWebhooksListFetch', getWebhooksListFetch);
}
